import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Inject,
	Pipe,
	PipeTransform,
	ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {RestService} from "../immerdrin/rest.service.interface";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {OaseDeleteDialogComponent} from "../immerdrin/oase.delete.component";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {Kernbenutzer} from "./kernbenutzer.model";
import {Kerngruppe} from "../kerngruppe/kerngruppe.model";
import {KernbenutzerInsertEditComponent} from "./kernbenutzer.insertEdit.component";
import {KernbenutzerPasswordChangeComponent} from "./kernbenutzer.passwordChange.component";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {ErrorHelper} from "../../shared/error.helper";
// import {MatSelectModule} from "@angular/material/select";
// import {MatSelectModule} from "@angular/material/select";
import {FormsModule} from "@angular/forms";

const PATH_FILE = "app/protected/kernrecht/kernrecht.component.ts";
const OBJ_LNG_NAME = 'benutzer';
const BACKEND_PATH_PREFIX = 'benutzer';

@Pipe({
    name: 'dataPipeBenutzer',
    standalone:true

})
export class DataTablePipeBenutzer implements PipeTransform {
    constructor(private _logger: LoggerService) { }
    transform(array: Kernbenutzer[], query: string): Kernbenutzer[] {
        this._logger.log(PATH_FILE + ' - transform BEGIN');
        this._logger.log(PATH_FILE + ' - transform array: ', array);
        this._logger.log(PATH_FILE + ' - transform query: ', query);
        if (query) {
            return array.filter((value: Kernbenutzer, index: number, arr: Kernbenutzer[]) =>
                value.email != null && value.email.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                value.name != null && value.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                value.login != null && value.login.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
        }
        return array;
    } // transform
} // class DataTablePipe


@Component({
    selector: 'oase-kernbenutzer',
    templateUrl: './kernbenutzer.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, FlexModule]

})
export class KernbenutzerComponent extends Tabelle<Kernbenutzer> {
    kerngruppen: Kerngruppe[] = new Array<Kerngruppe>();

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public breadcrumbService: BreadcrumbService,
        public snackBar: MatSnackBar,
        public authService: AuthService,
        public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
        public changeDetectorRef: ChangeDetectorRef,
        public sessService: SessionService,
        public title: Title,
        public _logger: LoggerService) {

        super( route, router, breadcrumbService, snackBar,
            authService, http, translation, dialog, media, changeDetectorRef,
            sessService, title, _logger, apiConfigService, {
                OBJ_LNG_NAME: OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
                ROUTE_NAME: "/kernbenutzer",
                PATH_FILE: PATH_FILE,
                DEFAULT_SORT_COLUMN: "login",
                extraDataForAdding: { }
            }
        );
        this.displayedColumns = ['login', 'name', 'email', 'kerngruppe', 'aktiv', 'admin'];
    }

    extraInit() {
      this.getKernGruppen();
      super.extraInit();
    }

    createNewElement() {
        return new Kernbenutzer();
    }

    loeschenSpalteName() {
        return "login";
    }

    getApiParams() {
      return "seite";
    }

    vorHinzufuegen(element) {
        element.kerngruppenAlle = this.kerngruppen;
        element.passwort = null;
        element.passwortwiederholung = null;
    }

    zeigeLoeschenMaske(element: any) {
        this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
    }

    zeigeHinzufuegenMaske() {
        this._zeigeHinzufuegenMaske(KernbenutzerInsertEditComponent);
    }

    zeigeBearbeitenMaske(element) {
        element.kerngruppenAlle = this.kerngruppen;
        this._zeigeBearbeitenMaske(element, KernbenutzerInsertEditComponent);
    }

    zeigePasswortMaske(element) {
        this._zeigeBearbeitenMaske(element, KernbenutzerPasswordChangeComponent);
    }

    private getKernGruppen() {
        this._logger.log(PATH_FILE + ' - getKategorien Begin');

        this.ladedaten = true;

        this.http.get<Kerngruppe[]>(this.apiConfigService.REST_API_BASE() + 'gruppe/liste').subscribe( (res) => {
                // this.authService.storeNewToken(res); // Das token mit dem vom Server neu gelieferten erneuern
                this.ladedaten = false;
                this.kerngruppen = res;

            },
            err => {
                this.ladedaten = false;
                ErrorHelper.handleError(err,"Fehler beim holen der Kerngruppen",this._logger, this.translation);
            },
            () => {
                this.ladedaten = false;
                this._logger.log(PATH_FILE + ' - getKernGruppen FERTIG');
                this._logger.log(PATH_FILE + ' - getKernGruppen kerngruppen: ', this.kerngruppen)
            }
        );
    }

    behandleGruppenaenderungen(kernbenutzer: Kernbenutzer) {
        this._logger.log(PATH_FILE + ' - behandleGruppenaenderungen BEGIN');
        this._logger.log(PATH_FILE + ' - behandleGruppenaenderungen kernbenutzer: ', kernbenutzer);

        let snacknachricht = this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate('kerngruppe.typ') });
        this.speichern(kernbenutzer, snacknachricht, false); // false ... Tabelle nicht neu laden
    } // behandleGruppenaenderungen

    // such comparison is needed for mat-select
    compareMitId(item1, item2) {
      return item1 && item2 ? item1.id === item2.id : item1 === item2;
    }

    public wechsleAktiv(element: any) {
        this._logger.log(this.PATH_FILE + " - wechsleAktiv "+OBJ_LNG_NAME+": " + element);

        element.aktiv = !element.aktiv;

        let snacknachricht = this.translation.translate(element.aktiv ? 'allgemein.daten.aktiviert' : 'allgemein.daten.deaktiviert', { typ: this.translation.translate(OBJ_LNG_NAME + '.typ') });
        this.speichern(element, snacknachricht); // false ... Tabelle nicht neu laden
    } // wechsleAktiv


}
